import { pilot } from '~/services/serviceInstances';

interface Request {
  id: string;
  data: any;
}

export const updateAlert = async ({ id, data }: Request) => {
  return await pilot.patch(`/alert/${id}/`, { ...data });
};
